import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "After a few iterations the crosstalk is reduced to a barely noticeable difference. This is sufficient to reproduce a binaural signal with loudspeakers.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/21/principle/principle-5.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
